import { useController } from 'react-hook-form';
import { SelectProps, SelectValueType, SingleSelectProps, TypeaheadSelect } from 'ui/selects';
import { FieldProps } from './types';

export type TypeaheadBasicSelectProps<TValue extends SelectValueType = string> = Omit<
  SelectProps<TValue>,
  'defaultValues' | 'isError' | 'onSelect'
> &
  SingleSelectProps &
  FieldProps<TValue>;

export const TypeaheadSelectField = <TValue extends SelectValueType = string>({
  name,
  defaultValue,
  ...rest
}: TypeaheadBasicSelectProps<TValue>) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
  });

  return (
    <TypeaheadSelect
      {...rest}
      isError={!!error}
      defaultValues={[value]}
      onSelect={([selectedValue]) => onChange(selectedValue)}
    />
  );
};
